import Button from "@/components/forms/Button/Button";
import { useSearch } from "wouter";
import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import Flex from "@/components/Flex/Flex";
import Alert from "@/components/Alert/Alert";
import Link from "@/components/Link/Link";
import { NotificationType, useNotificationContext } from "@/contexts/NotificationContext";

const intervalID = { id: null };
export default function ResetEmailSentPage() {
  const searchParams = new URLSearchParams(useSearch());
  const { showNotification } = useNotificationContext();
  const [resendTimestamp, setResendTimestamp] = useState<Date>(null);
  const [resendTimeRemaining, setResendTimeRemaining] = useState<Date>(null);

  useEffect(() => {
    if (resendTimestamp) {
      clearInterval(intervalID.id);
      intervalID.id = setInterval(() => {
        const remaining = resendTimestamp.getTime() - new Date().getTime();
        if (remaining < 0) {
          setResendTimeRemaining(null);
          setResendTimestamp(null);
          return clearInterval(intervalID.id);
        }
        setResendTimeRemaining(new Date(remaining));
      }, 900);
    }
    return () => clearInterval(intervalID.id);
  }, [resendTimestamp])

  const email = searchParams.get("email");
  const successMsg = `If ${email} matches an account, then we’ve sent you an email containing further instructions for resetting your password.`;

  const handleResendLink = async () => {
    setResendTimestamp(new Date(new Date().getTime() + 60_000)); // 1 minute from now
    try {
      await API.forgotPassword({email: email});
      showNotification("Reset link has been re-sent!\nPlease check your email to reset your password.", NotificationType.SUCCESS);
    } catch (err) {
      showNotification("Failed to send forgot password email!", NotificationType.ERROR);
    }
  };

  return (
    <>
      <Flex direction="column" gap={4}>
        <Alert type="success" message={successMsg} />
        <p>
          If you haven’t received an email within a minute, check your spam, or&nbsp;
          <Button 
            type="link"
            disabled={!!resendTimeRemaining}
            onClick={handleResendLink}>resend{resendTimeRemaining ? ` (${resendTimeRemaining.getSeconds()})` : undefined}
          </Button>.
        </p>

        <Flex justify="center"><Link href="/auth/login">Return to Log in</Link></Flex>

      </Flex>
    </>
  );
}
